import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import PAE from "./pages/PAE/PAE";
import Calls from "./pages/Calls/Calls.js";
import Login from "./pages/Login/index.js";
import Users from "./pages/Users/Users.js";
import Usinas from "./pages/Usinas/Usinas.js";
import AlterarSenha from "./pages/AlterarSenha";
import Dashboard from "./pages/Dashboard/index.js";
import Contacts from "./pages/Contacts/Contacts.js";
import RecuperarSenha from "./pages/RecuperarSenha";
import Functions from "./pages/Functions/Functions.js";
import NivelResp from "./pages/NivelResp/NivelResp.js";
import OccurrenceType from "./pages/OccurrenceType/OccurrenceType.js";

export default function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/pae" component={PAE} />
                <Route path="/calls" component={Calls} />
                <Route path="/users" component={Users} />
                <Route path="/" exact component={Login} />
                <Route path="/usinas" component={Usinas} />
                <Route path="/contacts" component={Contacts} />
                <Route path="/dashboard" component={Dashboard} />
                <Route path="/functions" component={Functions} />
                <Route path="/nivelresp" component={NivelResp} />
                <Route path="/occurrenceType" component={OccurrenceType} />
                <Route path="/recuperar-a-senha" component={RecuperarSenha} />
                <Route path="/alterar-a-senha/:token" component={AlterarSenha} />
            </Switch>
        </BrowserRouter>
    );
}
